export enum Status {
	Accepted = 'ACCEPTED',
	Denied = 'DENIED',
	Draft = 'DRAFT',
	Processing = 'PROCESSING',
	Ready = 'READY',
	Uninitialized = 'UNINITIALIZED',
	MissingCoapplicantData = 'MISSING_COAPPLICANT_DATA',
}
